module.exports = __webpack_public_path__ + "static/media/bookmark.bf5f2d10.png";